import { every } from 'lodash'

function isAddressBlank(entity, type) {
  return every(entity, (value, key) => !key.startsWith(type) || !value)
}

export default isAddressBlank
